const FAQS = [
  {
    q: '什么是下拉式漫画阅读？和传统翻页有什么区别？',
    a: '下拉式漫画阅读是一种更流畅的阅读模式，你只需向下滑动页面，漫画内容就会像瀑布一样连续呈现，无需点击翻页按钮。相比传统翻页漫画，下拉式阅读减少了操作步骤，让追漫体验更加丝滑，特别适合在移动端快速浏览长篇连载。',
  },
  {
    q: '无弹窗漫画模式真的完全没有广告吗？',
    a: '是的。爱漫画网的无弹窗漫画模式完全移除了所有弹出式广告、悬浮窗和插屏干扰。我们深知弹窗广告对阅读体验的破坏，因此从技术层面彻底屏蔽了这类干扰元素，为你提供真正纯净的在线阅读环境。',
  },
  {
    q: '漫画全屏观看支持哪些设备？',
    a: '漫画全屏观看功能支持桌面端、平板和手机全平台。在桌面浏览器中，按 F11 或点击全屏按钮即可进入沉浸式全屏模式；在移动端，横屏模式下自动适配全屏显示，配合下拉式阅读，带来影院级的追漫体验。',
  },
  {
    q: '爱漫画网的漫画资源是否可以免费阅读？',
    a: '可以。平台上的全部漫画资源均支持免费在线阅读。我们致力于降低漫画爱好者的阅读门槛，让更多人能够轻松享受优质的漫画内容。无需订阅、无需会员，打开即读。',
  },
  {
    q: '漫画更新频率是怎样的？如何第一时间追到最新章节？',
    a: '我们与多个内容渠道保持同步，热门连载作品每日更新。你可以关注首页的"漫画快讯"模块，或定期查看"人气榜单"中标记的最新更新状态。遇到喜欢的作品，建议收藏后定期回来查看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
              <i className="ri-question-answer-line text-accent-600 text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          </div>

          <div className="space-y-4">
            {FAQS.map((faq, i) => (
              <details
                key={i}
                className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between px-5 py-4 md:px-6 md:py-5 list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-8">
                    {faq.q}
                  </h3>
                  <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:hidden">
                    <i className="ri-add-line text-lg"></i>
                  </div>
                  <div className="w-6 h-6 flex-shrink-0 hidden group-open:flex items-center justify-center text-primary-500">
                    <i className="ri-subtract-line text-lg"></i>
                  </div>
                </summary>
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}